import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  collection,
  getDocs,
  where,
  query,
  orderBy,
  startAfter,
  limit,
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../firebase.config';
import { scrollToTop } from '../helper_functions/scrollToTop';
import { toast } from 'react-toastify';
import { FaCloudDownloadAlt, FaRegArrowAltCircleUp } from 'react-icons/fa';
import { BsArrowReturnLeft } from 'react-icons/bs';
import UserBox from '../components/UserBox';
import Spinner from '../components/Spinner';

function BookLibrary() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastFetchedBook, setLastFetchedBook] = useState(null);

  const auth = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const listRef = collection(db, 'books');
        const q = query(
          listRef,
          where('userRef', '==', auth.currentUser.uid),
          orderBy('timestamp', 'desc'),
          limit(10)
        );

        const querySnap = await getDocs(q);

        const lastVisible = querySnap.docs[querySnap.docs.length - 1];
        setLastFetchedBook(lastVisible);

        const results = [];

        querySnap.forEach(doc => {
          return results.push({
            id: doc.id,
            data: doc.data(),
          });
        });

        setBooks(results);
        setLoading(false);
      } catch (error) {
        toast.error('Could not fetch data');
      }
    };

    fetchBooks();

    //eslint-disable-next-line
  }, []);

  const onFetchMoreBooks = async () => {
    try {
      const listRef = collection(db, 'books');

      const q = query(
        listRef,
        orderBy('timestamp', 'desc'),
        startAfter(lastFetchedBook),
        limit(10)
      );

      const querySnap = await getDocs(q);

      const lastVisible = querySnap.docs[querySnap.docs.length - 1];
      setLastFetchedBook(lastVisible);

      const results = [];

      querySnap.forEach(doc => {
        return results.push({
          id: doc.id,
          data: doc.data(),
        });
      });

      setBooks(prevState => [...prevState, ...results]);
      setLoading(false);
    } catch (error) {
      toast.error('Could not fetch data');
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <UserBox />

      <div className="books-box">
        {books.length <= 0 ? (
          <h3 className="heading-3">No books in library</h3>
        ) : (
          <>
            {books.map((val, index) => (
              <div className="books-box__cell" key={index}>
                <img
                  src={val.data.imgUrls}
                  alt="book cover"
                  className="image"
                />
                <h3 className="heading-3">{val.data.author}</h3>
                <h4 className="heading-4">{val.data.title}</h4>
                <p className="paragraph-s paragraph-bold">
                  {val.data.language}
                </p>
                <p className="paragraph-s paragraph-bold">
                  {val.data.pages} pages
                </p>
                <p className="paragraph-s paragraph-bold">
                  ISBN {val.data.isbn}
                </p>
              </div>
            ))}
          </>
        )}
      </div>

      <div className="books-box__bottom">
        <div className="books-box__bottom-cell">
          <FaCloudDownloadAlt className="icon" onClick={onFetchMoreBooks} />
          <p className="paragraph-bold">load more</p>
        </div>

        <div className="books-box__bottom-cell">
          <FaRegArrowAltCircleUp
            className="icon"
            onClick={() => {
              scrollToTop();
            }}
          />
          <p className="paragraph-bold">back on top</p>
        </div>

        <div className="books-box__bottom-cell">
          <BsArrowReturnLeft
            className="icon"
            onClick={() => {
              navigate('/my-library');
            }}
          />
          <p className="paragraph-bold">my library</p>
        </div>
      </div>
    </>
  );
}

export default BookLibrary;
